import { useCallback, useState } from 'react';
import { authApi } from '../../api/auth';
import { GQLArgs } from '../../types';

export const useMutationLogin = (
  args?: GQLArgs<{ createSessionWithPassword: { token: string } }>,
) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ createSessionWithPassword: { token: string } } | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { email: string; password: string } }) => {
      setLoading(true);
      try {
        const res = await authApi.login(variables.email, variables.password);
        const token = res.data.token;
        localStorage.setItem('token', token);
        const shaped = { createSessionWithPassword: { token } };
        setData(shaped);
        args?.onCompleted?.(shaped);
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
